module.exports = __webpack_public_path__ + "static/media/Login.0fa8c51f.svg";